<template>
  <div class="overall-bg p-0">
    <b-container>
      <b-row class="tabviewtable">
        <b-col>
          <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
            <div class="">
              <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
                <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['Code'] !== ''">
                <span>Code: {{ filterItemsArray[0]["Code"] }}</span>
                <span @click="removeChip('Code')"><i class="pi pi-times"></i>
                </span>
              </div>
            </div>
            <div class="">
              <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                Clear all
              </button>
            </div>
          </div>
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <itemIssueGrnReturnFilters @updatedcode="Emitcode" :removechiptype="removechipvalue" />
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="IsAddButton" v-if="items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate
                  " eheader="Purchase Indent" econtent="Purchase Indent" eimg="/src/assets/Img/icons/sub-tax.svg"
                    @createNew="IsCreate" />
                  <div :class="!visible ? 'table-width-80' : ''">
                    <Tableview v-if="items.length !== 0 ||
                      SearchValue.inputValue ||
                      SearchValue.fromDate ||
                      SearchValue.toDate
                    " :value="items" class="p-datatable-gridlines" :rows="10" dataKey="Id" :rowHover="true"
                      filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
                      :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                      :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false"
                      :searchbox1="true" @search="SearchBox" :exceldownload="true" :filterbtn="true"
                      :showColumnFilters="false">
                      <template v-slot:exceldownload>
                        <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                          :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                      </template>
                      <template v-slot:filter>
                        <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                          :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                          @click="visible = !visible"></i>
                      </template>
                      <template v-slot:Add v-if="IsAddButton">
                        <span class="add">
                          <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                        </span>
                      </template>
                      <template v-slot:status="{ data }">
                        <!-- {{ data.IsDraft}} -->
                        <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                        <OrangeStatus name="Pending" v-if="data.IsDraft != '1' && data.Status == '0'" />
                        <!-- <BlueStatus name="Converted To Quote Amendment" v-if="data.Status == '1'" /> -->
                        <!-- <BlueStatus name="Converted To GRN" v-if="data.Status == '2'" /> -->

                      </template>
                      <template v-slot:action="{ data }">
                        <span>
                          <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                            @click="toggle($event, data)" />
                        </span>
                      </template>
                    </Tableview>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate
              " eheader="Purchase Indent" econtent="Purchase Indent" eimg="/src/assets/Img/icons/sub-tax.svg"
                @createNew="IsCreate" />
              <MobileViewCardHeader :totalRecords="rowsCount" :state="state" @search="SearchBox" v-if="items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              ">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <p class="light-name">{{ item["DocNo"] }} /</p>
                        <p class="light-name">{{ item["DocDate"] }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item count :</p>
                      <p class="small-name">{{ item["ItemCount"] }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item value :</p>
                      <p class="small-name">{{ item["Amount"] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <!-- Commenly Used Components -->
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(DataEdit)"
    @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(DataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <Toast />
  <!-- Commenly Used Components -->
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";

import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import commonService from "../../../Service/WithoutStockAffectService";
import { useRoute, useRouter } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import itemIssueGrnReturnFilters from "../../../../../modules/Inventory/components/Filters/itemIssueGrnReturnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../components/FormComponents/FilterForm.vue";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import ExportOption from "../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    itemIssueGrnReturnFilters,
    FilterForm,
    CrystalReportPrintPopUp,
    ExportOption,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ["row-click"],
  setup(props, { emit }) {
    /* variable declaration*/
    let loading = ref(false);
    let showitemfield = ref(false);
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    const ObjData = ref();
    let content = ref("");
    const toast = useToast();
    const route = useRoute();
    let visible = ref(false)
    const routes = useRoute();

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    let DataEdit = ref();

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    // get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 11,
      HeaderTitle: "Purchase Indent",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("Purchase Indent");
    let ExportOption = ref("");

    watch(props, (newValue: any) => {
      debugger;
      console.log("props Changed", newValue.FunctionRights);
      Rights.value.Create = newValue.FunctionRights.Create;
      Rights.value.Update = newValue.FunctionRights.Update;
      Rights.value.Read = newValue.FunctionRights.Read;
      Rights.value.Delete = newValue.FunctionRights.Delete;
      Object.keys(ObjOperationId.value).forEach((key) => {
        if (newValue.FunctionRights[key])
          ObjOperationId.value[key] = newValue.FunctionRights[key];
      });
    }, { deep: true });

    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    const rowsCount = ref(0);
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocNo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Amount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      PIStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t('storetabdetails.pi.sno'),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        field: "status",
        fieldDisplay: "false",
        header: t("storetabdetails.quotes.Status"),
        slot: "status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.pi.BranchName'),
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pi.Date'),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pi.PI'),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pi.ItemCount'),
        field: "ItemCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass right_td",
        class: "smallwidth",
      },

      {
        header: t('storetabdetails.pi.Value'),
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const menu = ref();
    let actioneEdit = ref(false);
    const IsPending = ref(false);

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      actioneEdit.value = data.Status == 0 && data.IsApproved != 1 && data.IsConsigneeItem == 0 || data.IsDraft == 1 ? true : false;
      IsPending.value = (((data.Status == '0' || data.Status == '3') && data.IsDraft != '1') && data.IsApproved == '1') ? true : false;
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: actioneEdit,
            command: async () => {
              Editdata(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actioneEdit,
            command: async () => {
              Deletedata(ObjData);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(ObjData);
            },
          },
        ],
      },
    ]);

    // row click for table
    function RowClick(event: any) {
      debugger;
      console.log(event.data);
      router.push({
        path: "/PurchaseIndentDetails",
        query: {
          PIId: event.data ? event.data["StockTransId"] : event["StockTransId"],
        },
      });
      rowFocus.value = true;
    }

    function Editdata(data) {
      debugger;
      DataEdit.value = data;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      debugger;
      DataEdit.value = data;
      Deletemodel.value = true;
      content.value = t('confirmation.deletecontent');
    }

    const globalFilterFields = ref(headers.map((col) => col.field));

    // let dataValue = {
    //   StoreId: "",
    //   status: "",
    // };
    // watch(props, (newValue) => {
    //   debugger;
    //   Object.assign(dataValue, newValue.propsParams);
    //   if (dataValue.StoreId) {
    //     items.value = [];
    //     StoreId = dataValue.StoreId;
    //     status = dataValue.status;
    //     IsShow();
    //   }
    // });

    let ParamValues = ref({
      StockWoTransTMId: 0,
      StoreId: 0,
      DocNo: "",
      DocType: 2,
      status: 0,
      OperationId: ObjOperationId.value.CreateId,
      EntityId: ObjOperationId.value.EntityId,
      StoreBrMapId: 0,
      BranchId: 0,
      IsDraft: 0
      //Type: "",
    });

    let QueryStringValue3: any = route.query;
    ParamValues.value.StoreId = QueryStringValue3["Id"];
    ParamValues.value.status = QueryStringValue3["status"];
    ParamValues.value.StoreBrMapId = Number(routes.query.storebranchmapid ?? 0)
    ParamValues.value.BranchId = Number(routes.query.BranchId ?? 0)


    const IsCreate = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
          (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
        router.push({
          path: "/PI",

          query: {
            data: JSON.stringify(ParamValues.value),
            param: "PI",
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsEdit(DataEdit) {
      debugger;
      ParamValues.value.DocNo = DataEdit.value["DocNo"];
      ParamValues.value.StockWoTransTMId = DataEdit.value["StockTransId"];
      ParamValues.value.IsDraft = DataEdit.value["IsDraft"];
      (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
        (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
      router.push({
        path: "/PI",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "PI",
        },
      });
    }
    let dataValue = {
      Id: 0,
      status: 0,
      // Type: "",
    };

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        ParamValues.value.StoreId = dataValue.Id;
        ParamValues.value.status = dataValue.status;
        IsShow();
      }
    });

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    function SearchBox(value) {
      SearchValue.value.inputValue = value;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        debugger;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        let Flag = 1,
          searchOption = "";

        let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" + ""


        //  and sm.BranchId=" + usersData.BranchId
        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          2,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        // response["result"] = response["result"].filter(
        //   (x) =>
        //     x.HospitalId == usersData.OrganizationId &&
        //     x.BranchId == usersData.BranchId
        // );

        items.value = response["result"];

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        debugger;
        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        let Flag = 1,
          searchOption = "";

        let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and (COALESCE('" + usersData.BranchId + "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" + usersData.BranchId + "', ',')))" + ""

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          2,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        // response["result"] = response["result"].filter(
        //   (x) =>
        //     x.HospitalId == usersData.OrganizationId &&
        //     x.BranchId == usersData.BranchId
        // );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.value.Id;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    //Delete Values in Table
    async function IsDelete(DataEdit) {
      debugger;
      console.log(DataEdit.value["StockTransId"]);
      try {
        const response = await commonService.DeleteStockWOTM(
          DataEdit.value["StockTransId"]
        );
        let msg = "";
        msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          Deletemodel.value = false;
          deletepop.value = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    }
    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      Code: "",
    });

    let emitedfilterItems = ref({
      Code: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);
    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      // filterItems.value.LineOfBusiness = ServiceTypeNames;
      // filterItems.value.Type = TaskTypeNames;
      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.Code = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    return {
      showitemfield,
      items,
      headers,
      loading,
      paramValue,
      onRowClick,
      IsShow,
      IsEdit,
      IsDelete,
      IsCreate,
      loading1,
      globalFilterFields,
      filters,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      RowClick,
      DataEdit,
      rowsCount,
      state,
      menu,
      toggle,
      itemListed,
      content,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      Emitcode,
      removeChip,
      removechipvalue,
      SearchBox,
      ShowRows,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      windowWidth,
      visible,
    };
  },
});
</script>
